// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestId } from './Harvest';
import { batchTypeEnum } from './BatchTypeEnum';
import { operatorId } from './Operator';
import { z } from 'zod';
export const harvestBranchId = (z.number());
export const harvestBranch = z.object({
    id: harvestBranchId,
    harvest_id: harvestId,
    parent_branch_id: harvestBranchId.nullable(),
    letter: z.string().nullable(),
    input_material: batchTypeEnum.nullable(),
    sort_order: z.number(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
});
export const harvestBranchInitializer = z.object({
    id: harvestBranchId.optional(),
    harvest_id: harvestId,
    parent_branch_id: harvestBranchId.optional().nullable(),
    letter: z.string().optional().nullable(),
    input_material: batchTypeEnum.optional().nullable(),
    sort_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
export const harvestBranchMutator = z.object({
    id: harvestBranchId.optional(),
    harvest_id: harvestId.optional(),
    parent_branch_id: harvestBranchId.optional().nullable(),
    letter: z.string().optional().nullable(),
    input_material: batchTypeEnum.optional().nullable(),
    sort_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=HarvestBranch.js.map